import browser from '@openclassrooms/utils/browser';
import openZendeskWidget from './services/openZendeskWidget';

export { openZendeskWidget };

function initSupport() {
  const elements = [...browser.document.querySelectorAll('.js-zendesk-show')];

  elements.forEach((element) => {
    element.addEventListener('click', openZendeskWidget);
  });
}

export default initSupport;
